import ExaminationEventDetailsForm, {
  ExaminationEventDetailsProps,
} from './ExaminationEventDetailsForm';

export default ExaminationEventDetailsForm;
export type { ExaminationEventDetailsProps };
